import React, { useState } from 'react';
import { Modal } from '@components/molecules/Modal';
import { FormGroup } from '@components/molecules/form/FormGroup';
import { Input } from '@components/atoms/Input';
import { TextareaInput } from '@components/atoms/TextareaInput';
import { useTranslation } from '@hooks/useTranslation';

interface SaveAsTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, description?: string) => void;
  isSaving?: boolean;
}

export const SaveAsTemplateModal: React.FC<SaveAsTemplateModalProps> = ({ isOpen, onClose, onSave, isSaving }) => {
  const t = useTranslation('aiPlan');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isLoading={isSaving}
      title={t.commitSaveTemplate}
      confirmText={t.commitSaveTemplate}
      handleConfirm={() => name.trim() && onSave(name.trim(), description || undefined)}>
      <div className="flex flex-col gap-4">
        <FormGroup htmlFor="templateName" label={t.saveTemplateNameLabel}>
          <Input name="templateName" value={name} onChange={(e) => setName(e.target.value)} data-testid="save-template-name" />
        </FormGroup>
        <FormGroup htmlFor="templateDescription" label={t.saveTemplateNameLabel}>
          <TextareaInput rows={3} name="templateDescription" value={description} onChange={(e) => setDescription(e.target.value)} />
        </FormGroup>
      </div>
    </Modal>
  );
};

export default SaveAsTemplateModal;
